import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: "app-fashion-video",
  templateUrl: "./fashion-video.component.html",
  styleUrls: ["./fashion-video.component.css"],
})
export class FashionVideoComponent implements OnInit {
  constructor(public router: Router) {}

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
  }
}
